import React from 'react';
import { Hero } from './components/Hero';
import { ValueProps } from './components/ValueProps';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Reviews } from './components/Reviews';
import { PurchaseNotification } from './components/PurchaseNotification';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen bg-navy font-sans selection:bg-orange selection:text-white" data-id="element-0">
      <TopBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ValueProps data-id="element-4" />
        <Tomos data-id="element-5" />
        <Bonuses data-id="element-6" />
        <Reviews data-id="element-7" />
        <Pricing data-id="element-8" />
        <FAQ data-id="element-9" />
      </main>

      <footer className="bg-navy-light text-center py-6 text-gray-500 text-xs px-4 border-t border-navy" data-id="element-10">
        <p data-id="element-11">
          © {new Date().getFullYear()} Kit de Psicología Pro. Todos los
          derechos reservados.
        </p>
      </footer>

      <PurchaseNotification data-id="element-12" />
    </div>;
}